<div class="container">
    <div class="edit-container">
        <h5>Fields marked with (*) are required.</h5>

        <app-edit-name [df]="dfToEdit" (save)="onSave($event)" (cancelEvent)="onCancel()"></app-edit-name>
    </div>
</div>